module.exports = __webpack_public_path__ + "img/icon-smart-reader.32311338.svg";